var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as Utils from '@datocms/rest-client-utils';
import BaseResource from '../../BaseResource';
var MenuItem = /** @class */ (function (_super) {
    __extends(MenuItem, _super);
    function MenuItem() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Create a new menu item
     *
     * Read more: https://www.datocms.com/docs/content-management-api/resources/menu-item/create
     *
     * @throws {ApiError}
     * @throws {TimeoutError}
     */
    MenuItem.prototype.create = function (body) {
        return this.rawCreate(Utils.serializeRequestBody(body, {
            type: 'menu_item',
            attributes: ['label', 'external_url', 'position', 'open_in_new_tab'],
            relationships: ['item_type', 'item_type_filter', 'parent'],
        })).then(function (body) {
            return Utils.deserializeResponseBody(body);
        });
    };
    /**
     * Create a new menu item
     *
     * Read more: https://www.datocms.com/docs/content-management-api/resources/menu-item/create
     *
     * @throws {ApiError}
     * @throws {TimeoutError}
     */
    MenuItem.prototype.rawCreate = function (body) {
        return this.client.request({
            method: 'POST',
            url: '/menu-items',
            body: body,
        });
    };
    /**
     * Update a menu item
     *
     * Read more: https://www.datocms.com/docs/content-management-api/resources/menu-item/update
     *
     * @throws {ApiError}
     * @throws {TimeoutError}
     */
    MenuItem.prototype.update = function (menuItemId, body) {
        return this.rawUpdate(Utils.toId(menuItemId), Utils.serializeRequestBody(body, {
            id: Utils.toId(menuItemId),
            type: 'menu_item',
            attributes: ['label', 'external_url', 'position', 'open_in_new_tab'],
            relationships: ['item_type', 'item_type_filter', 'parent'],
        })).then(function (body) {
            return Utils.deserializeResponseBody(body);
        });
    };
    /**
     * Update a menu item
     *
     * Read more: https://www.datocms.com/docs/content-management-api/resources/menu-item/update
     *
     * @throws {ApiError}
     * @throws {TimeoutError}
     */
    MenuItem.prototype.rawUpdate = function (menuItemId, body) {
        return this.client.request({
            method: 'PUT',
            url: "/menu-items/".concat(menuItemId),
            body: body,
        });
    };
    /**
     * List all menu items
     *
     * Read more: https://www.datocms.com/docs/content-management-api/resources/menu-item/instances
     *
     * @throws {ApiError}
     * @throws {TimeoutError}
     */
    MenuItem.prototype.list = function (queryParams) {
        return this.rawList(queryParams).then(function (body) {
            return Utils.deserializeResponseBody(body);
        });
    };
    /**
     * List all menu items
     *
     * Read more: https://www.datocms.com/docs/content-management-api/resources/menu-item/instances
     *
     * @throws {ApiError}
     * @throws {TimeoutError}
     */
    MenuItem.prototype.rawList = function (queryParams) {
        return this.client.request({
            method: 'GET',
            url: '/menu-items',
            queryParams: queryParams,
        });
    };
    /**
     * Retrieve a menu item
     *
     * Read more: https://www.datocms.com/docs/content-management-api/resources/menu-item/self
     *
     * @throws {ApiError}
     * @throws {TimeoutError}
     */
    MenuItem.prototype.find = function (menuItemId) {
        return this.rawFind(Utils.toId(menuItemId)).then(function (body) {
            return Utils.deserializeResponseBody(body);
        });
    };
    /**
     * Retrieve a menu item
     *
     * Read more: https://www.datocms.com/docs/content-management-api/resources/menu-item/self
     *
     * @throws {ApiError}
     * @throws {TimeoutError}
     */
    MenuItem.prototype.rawFind = function (menuItemId) {
        return this.client.request({
            method: 'GET',
            url: "/menu-items/".concat(menuItemId),
        });
    };
    /**
     * Delete a menu item
     *
     * Read more: https://www.datocms.com/docs/content-management-api/resources/menu-item/destroy
     *
     * @throws {ApiError}
     * @throws {TimeoutError}
     */
    MenuItem.prototype.destroy = function (menuItemId) {
        return this.rawDestroy(Utils.toId(menuItemId)).then(function (body) {
            return Utils.deserializeResponseBody(body);
        });
    };
    /**
     * Delete a menu item
     *
     * Read more: https://www.datocms.com/docs/content-management-api/resources/menu-item/destroy
     *
     * @throws {ApiError}
     * @throws {TimeoutError}
     */
    MenuItem.prototype.rawDestroy = function (menuItemId) {
        return this.client.request({
            method: 'DELETE',
            url: "/menu-items/".concat(menuItemId),
        });
    };
    MenuItem.TYPE = 'menu_item';
    return MenuItem;
}(BaseResource));
export default MenuItem;
//# sourceMappingURL=MenuItem.js.map